import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import logo from '../../../../Assets/img/logo.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Api from '../../../../component/Api';
import Header from './Header';
import useMenu from '../../hooks/template/useMenu';

const sidebarStyles = `
    @keyframes shimmer {
        0% { background-position: -1000px 0; }
        100% { background-position: 1000px 0; }
    }
    @keyframes fadeIn {
        from { opacity: 0; transform: translateX(-6px); }
        to { opacity: 1; transform: translateX(0); }
    }
    @keyframes slideIn {
        from { transform: translateX(-100%); }
        to { transform: translateX(0); }
    }

    html, body, #root {
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .template-shell {
        display: flex;
        flex-direction: column;
        height: 100vh;
        overflow: hidden;
    }

    .template-body {
        display: flex;
        flex: 1 1 0;
        overflow: hidden;
        position: relative;
    }

    .sidebar-panel {
        width: auto;
        flex-shrink: 0;
        background: #f4f4f4;
        border-right: 1px solid rgba(0,0,0,0.08);
        box-shadow: 0 0 10px #0000001a;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        overflow-x: hidden;
        transition: transform 0.25s ease, box-shadow 0.25s ease;
        z-index: 200;
        border-radius: 0 !important;
        margin: 0 !important;
    }

    .sidebar-panel.sidebar-mobile {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        transform: translateX(-100%);
        box-shadow: none;
        width: auto;
        overflow-y: auto !important;
        overflow-x: hidden !important;
    }
    
    @media (max-width: 768px) {
        .nav-item-side.main-menu-item {
            margin-left: 0 !important;
            margin-bottom: 0 !important;
        }
    }
    .sidebar-panel.sidebar-mobile.mobile-open {
        transform: translateX(0);
        box-shadow: 4px 0 24px rgba(0,0,0,0.15) !important;
        animation: slideIn 0.25s ease;
    }

    .sidebar-panel.fullscreen-hidden {
        display: none !important;
    }

    .nav-item-side {
        width: 100%;
        background: transparent !important;
        box-shadow: none !important;
        padding: 0 8px !important;
    }

    .sidebar-panel .card,
    .sidebar-panel .card-body,
    .sidebar-panel > div:not(.d-flex),
    .sidebar-panel .sidebar-inner-card {
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
        border-radius: 0 !important;
        margin: 0 !important;
    }

    .sidebar-panel::-webkit-scrollbar { width: 4px; }
    .sidebar-panel::-webkit-scrollbar-track { background: transparent; }
    .sidebar-panel::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }

    .sidebar-nav {
        flex: 1;
        padding: 8px 0;
        list-style: none;
        margin: 0;
        background: transparent !important;
        box-shadow: none !important;
        border: none !important;
    }

    .sidebar-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.35);
        z-index: 199;
    }

    .content-panel {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        min-width: 0;
        background: #f4f6f9;
    }
    .content-panel::-webkit-scrollbar { width: 6px; }
    .content-panel::-webkit-scrollbar-track { background: transparent; }
    .content-panel::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 3px; }

    .content-inner {
        background: #fff;
        border-radius: 10px;
        min-height: 100%;
    }

    .skeleton-wrapper { padding: 8px 0; }
    .skeleton-menu-item {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        margin: 0 8px 4px;
        gap: 12px;
        background: linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);
        background-size: 200% 100%;
        animation: shimmer 1.8s infinite linear;
        border-radius: 8px;
    }
    .dark-version .skeleton-menu-item {
        background: linear-gradient(90deg, #2a2a2a 0%, #3a3a3a 50%, #2a2a2a 100%);
        background-size: 200% 100%;
    }
    .skeleton-icon { width: 20px; height: 20px; border-radius: 4px; background: rgba(0,0,0,0.06); flex-shrink: 0; }
    .skeleton-text { height: 13px; flex: 1; background: rgba(0,0,0,0.06); border-radius: 4px; max-width: 110px; }

    .menu-fade-in { animation: fadeIn 0.3s ease; }

    .template-footer {
        background: #fff;
        border-top: 1px solid rgba(0,0,0,0.08);
        padding: 10px !important;
        text-align: center;
        font-size: 13px;
        color: #555;
        flex-shrink: 0;
        z-index: 300;
    }

    .nav-link-side {
        background: #e3d9d9;
        border-radius: 10px 10px 10px 10px !important;
    }

    .nav-link-side.active {
        background: linear-gradient(270deg,#6f2443,#8a2f55) !important;
        border-radius: 10px 10px 10px 10px !important;
    }

    .nav-item-side.main-menu-item {
        margin-bottom: 0 !important;
    }

    @media only screen and (max-width: 760px) {
        .card .card-body { padding: 0.5rem; }
        table, tbody, thead, th, td, tr { display: block; float: left; width: 100%; clear: both; }
        .table-sm> :not(caption)>*>* { padding: 0.25rem 0.35rem 0.25rem 0rem; }
        .table> :not(caption)>*>* { padding: 0.5rem 0.5rem 0.5rem 0rem; }
        thead tr { position: absolute; top: -9999px; left: -9999px; }
        tr { border: 1px solid #ccc; margin-bottom: 10px; padding: 10px; }
        td, th { border: none; border-bottom: 1px solid #eee; position: relative; display: flex; justify-content: space-between; box-sizing: border-box; padding: 10px; }
        td::before { content: attr(data-label); font-weight: bold; color: #6c757d; z-index: 10; padding: 0px 15px 0px 15px; }
        .dark-version td::before { background-color: #1A2035; }
        td.fixed-column { max-width: 100%; width: 100%; overflow: hidden; position: relative; display: flex; align-items: center; }
        .scrollable-wrapper { width: 100%; overflow: hidden; position: relative; }
        .scrollable-cell { min-width: 100%; }
    }
`;

const MenuSkeleton = () => (
    <>
        <style>{sidebarStyles}</style>
        <ul className="nav flex-column skeleton-wrapper">
            {[1, 2, 3].map(i => (
                <li key={i} style={{ width: '100%', listStyle: 'none' }}>
                    <div className="skeleton-menu-item">
                        <div className="skeleton-icon" />
                        <div className="skeleton-text" />
                    </div>
                </li>
            ))}
        </ul>
    </>
);

const Template = ({ children, viewComponents = {} }) => {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [toggleFullscreen, setToggleFullscreen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const {
        menuData, menuLoading, menuError, activeSubMenu, activeNestMenu,
        currentHash, studentId, hashParams,
        handleMenuClick, handleNestMenuClick, isMenuActive,
    } = useMenu(viewComponents);


    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => { setSidebarOpen(false); }, [currentHash]);

    useEffect(() => {
        document.body.style.overflow = sidebarOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [sidebarOpen]);

    const handleLogout = () => {
        const { http } = Api();
        http.get('logout')
            .then(response => {
                if (response.data.status_code === 'MSG6') {
                    sessionStorage.clear();
                    localStorage.clear();
                    navigate("/is");
                }
            })
            .catch(() => {
                sessionStorage.clear();
                localStorage.clear();
                window.location.reload();
            });
    };

    const renderContent = () => {
        if (Object.keys(viewComponents).length > 0) {
            const ViewComponent = viewComponents[currentHash] || viewComponents['home'];
            if (ViewComponent) return <ViewComponent hashParams={hashParams} studentId={studentId} />;
        }
        return children;
    };

    const sidebarClasses = [
        'sidebar-panel',
        isMobile ? 'sidebar-mobile' : '',
        isMobile && sidebarOpen ? 'mobile-open' : '',
        !isMobile && toggleFullscreen ? 'fullscreen-hidden' : '',
    ].filter(Boolean).join(' ');

    return (
        <>
            <style>{sidebarStyles}</style>
            <div className="template-shell">

                <Header
                    logo={logo}
                    handleLogout={handleLogout}
                    toggleFullscreen={toggleFullscreen}
                    setToggleFullscreen={setToggleFullscreen}
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                />

                {sidebarOpen && (
                    <div
                        className="sidebar-overlay d-md-none"
                        onClick={() => setSidebarOpen(false)}
                    />
                )}

                <div className="template-body">
                    <nav className={sidebarClasses}>
                        {menuLoading ? (
                            <MenuSkeleton />
                        ) : menuError ? (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '32px 16px',
                                gap: '10px',
                                color: '#999',
                                textAlign: 'center',
                            }}>
                                <i className="bi bi-exclamation-circle" style={{ fontSize: '28px', color: '#d9534f' }} />
                                <span style={{ fontSize: '13px' }}>Failed to load menu</span>
                            </div>
                        ) : (
                            <ul className="nav flex-column sidebar-nav menu-fade-in align-items-start pt-2 text-dark">
                                {menuData
                                    .filter(item => item.parent_id === null && item.status === "active")
                                    .sort((a, b) => a.order - b.order)
                                    .map(menuItem => (
                                        <li className="nav-item-side main-menu-item" key={menuItem.id}>
                                            <div
                                                className={`nav-link-side ${isMenuActive(`/${menuItem.url}`) || activeSubMenu === menuItem.id ? 'active' : ''}`}
                                                onClick={() => handleMenuClick(menuItem.id, `/${menuItem.url}`)}
                                            >
                                                <i className={`bi bi-${menuItem.icon} nav_icon`} />
                                                <span className="nav_name">{menuItem.label}</span>
                                                {menuData.some(item => item.parent_id === menuItem.id) && (
                                                    <ExpandMoreIcon
                                                        className={`nav_icon ${activeSubMenu === menuItem.id ? 'rotate' : ''}`}
                                                        style={{ marginLeft: 'auto', transition: 'transform 0.2s' }}
                                                    />
                                                )}
                                            </div>

                                            {activeSubMenu === menuItem.id && (
                                                <ul className="submenu sider" style={{ maxHeight: 'none', overflow: 'visible' }}>
                                                    {menuData
                                                        .filter(item => item.parent_id === menuItem.id && item.status === "active")
                                                        .sort((a, b) => a.order - b.order)
                                                        .map(submenuItem => (
                                                            <li className="sub-nav-item" key={submenuItem.id}>
                                                                <div
                                                                    className={`nav-link-side-sub ${isMenuActive(`/${submenuItem.url}`) || activeNestMenu === submenuItem.id ? 'active' : ''}`}
                                                                    onClick={() => handleNestMenuClick(submenuItem.id, `/${submenuItem.url}`)}
                                                                >
                                                                    <i className={`bi bi-${submenuItem.icon} nav_icon`} />
                                                                    <span className="nav_name1">{submenuItem.label}</span>
                                                                    {menuData.some(item => item.parent_id === submenuItem.id) && (
                                                                        <ExpandMoreIcon
                                                                            className={`nav_icon ${activeNestMenu === submenuItem.id ? 'rotate1' : ''}`}
                                                                            style={{ marginLeft: 'auto', transition: 'transform 0.2s' }}
                                                                        />
                                                                    )}
                                                                </div>

                                                                {activeNestMenu === submenuItem.id && (
                                                                    <ul className="nestmenu sider active" style={{ overflow: 'visible' }}>
                                                                        {menuData
                                                                            .filter(item => item.parent_id === submenuItem.id && item.status === "active")
                                                                            .map(nestmenuItem => (
                                                                                <li className="sub-nav-item" key={nestmenuItem.id}>
                                                                                    <div
                                                                                        className={`nav-link-side-sub1 ${isMenuActive(`/${nestmenuItem.url}`) ? 'active' : ''}`}
                                                                                        onClick={() => handleNestMenuClick(nestmenuItem.id, `/${nestmenuItem.url}`)}
                                                                                    >
                                                                                        <i className={`bi bi-${nestmenuItem.icon} nav_icon`} />
                                                                                        <span className="nav_name12">{nestmenuItem.label}</span>
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                            </ul>
                        )}
                    </nav>

                    <main className={`content-panel ${toggleFullscreen ? 'col-12' : ''}`}>
                        <div className="content-inner">
                            {renderContent()}
                        </div>
                    </main>
                </div>

                <footer className="template-footer">
                    <span>Mahatma Gandhi University, Priyadarsini Hills, Kottayam, Kerala, India – 686560</span>
                </footer>
            </div>
        </>
    );
};

export default Template;